import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";

export default function AdminLogin() {
  const { user, login, refresh } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user === undefined) refresh(); }, [user, refresh]);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(f.email, f.password); nav("/admin"); } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen bg-espresso flex items-center justify-center px-6 relative grain" data-testid="admin-login-page">
      <form onSubmit={submit} className="relative z-10 w-full max-w-sm bg-ivory p-10" data-testid="admin-login-form">
        <img src="/brand/logo-grey.webp" alt="Studio Fotografico Santarelli" className="h-11 w-auto" />
        <p className="eyebrow mt-10">Gestionale</p>
        <h1 className="font-serif text-4xl font-light mt-2">Accedi</h1>
        <input className="field mt-8" type="email" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-email-input" />
        <input className="field mt-4" type="password" placeholder="Password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-password-input" />
        <button disabled={busy} className="btn-ink w-full justify-center mt-10 disabled:opacity-50" data-testid="admin-login-btn">{busy ? "Accesso..." : "Entra"}</button>
      </form>
    </div>
  );
}
